<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <slot />
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
export default {
  components: {}
};
</script>
